import React from 'react'
import c from 'classnames'
import './index.styl'

const MSStepsModal = ({ activeScreen, userLogged = false, stepsItems = [] }) => {
  const active = activeScreen

  return (
    <div className={c('wrapperMSStepsModal', { centered: userLogged })}>
      {stepsItems.filter(i => i).map((i, ind) => (
        <div key={i} className={c('wrapperStep', { activeStep: active === i })}>
          <div className='wrapperCircle'>
            <div className='circle'>{ind + 1}</div>
            <div className='title'>{i}</div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MSStepsModal
